import { render } from "./affiliate-questions.vue?vue&type=template&id=b1d5d60e&scoped=true&ts=true"
import script from "./affiliate-questions.vue?vue&type=script&lang=ts"
export * from "./affiliate-questions.vue?vue&type=script&lang=ts"

import "./affiliate-questions.vue?vue&type=style&index=0&id=b1d5d60e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1d5d60e"]])

export default __exports__